import { gql } from '@apollo/client'
import { DTVFragment } from '../fragments/dtv.fragments'
import { getChildElementQuery } from '../queries/projectElements.queries'

export const RemoveProjectContentItemMutation = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
        mutation removeProjectContentItem(
            $input: RemoveProjectContentItemInput!,
            $rootArticleContentItemIds: [String],
            $productFamilyId: String!,
            $partType: TemplateItemPartType!,
            $projectId: String!,
            $isTrackChangeToggleOn: Boolean,
        ) {
            removeProjectContentItem(input: $input,
                isTrackChangeToggleOn: $isTrackChangeToggleOn,
                ) {
                contentItemNodes (input: {
                    projectId: $projectId,
                    productFamilyId: $productFamilyId,
                    templateItemPartType: $partType,
                    rootArticleContentItemId: $rootArticleContentItemIds,
                }) {
                    id
                    comments
                    textType
                    isProductGroup
                    isBestPractice
                    isGlobalBestPractice
                    ${elements}
                }
                documentTemplateView {
                    ...dtvFragment
                }
            }
        }
        ${DTVFragment}
    `
}

export const RemoveProductTypeContentItem = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
    mutation removeProjectContentItem(
        $input: RemoveProjectContentItemInput!,
        $nodeId: String!, 
        $rootArticleContentItemIds: [String],
        $productFamilyId: String!,
        $partType: TemplateItemPartType!,
        $projectId: String!,
        $isTrackChangeToggleOn: Boolean,
    ) {
        removeProjectContentItem(input: $input, 
            isTrackChangeToggleOn: $isTrackChangeToggleOn,
            ) {
            contentItemNodes (input: {
                projectId: $projectId,
                productFamilyId: $productFamilyId,
                templateItemPartType: $partType,
                rootArticleContentItemId: $rootArticleContentItemIds,
            }) {
                id
                comments
                textType
                isProductGroup
                isBestPractice
                isGlobalBestPractice
                ${elements}
            }
            projectNuggets {
                id
                projectProductTypeProperties {
                    id
                }
                projectProductTypePropertiesView(nodeId: $nodeId
                    isTrackChangeToggleOn: $isTrackChangeToggleOn) {
                    ...dtvFragment
                }
            }
        }
    }
    ${DTVFragment}
`
}
